import PropTypes from 'prop-types';
import { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';

const LoadingState = memo(({ loadingMessage }) => (
    <>
        <div className="animate-spin">
            <FontAwesomeIcon icon={faSpinner} className="w-10 h-10 text-gray-400 dark:text-[#3590BA]" />
        </div>
        <div className="mt-4 text-center font-medium text-gray-400 dark:text-gray-400">{loadingMessage}</div>
    </>
));

const EmptyState = memo(({ icon = faSearch, description = 'Search for a customer by name, phone number, or email', placeholder = 'Search Customer' }) => (
    <>
        <div className="relative">
            <div className="absolute inset-0 bg-primary/10 dark:bg-primary/20 blur-xl rounded-full"></div>

            <FontAwesomeIcon icon={icon} className="w-10 h-10 text-primary dark:text-gray-400" />
        </div>

        <div className="mt-2 text-lg text-center text-primary dark:text-gray-400">{placeholder}</div>
        <div className="mt-2 text-center text-gray-500 dark:text-gray-400">{description}</div>
    </>
));

const EmptyPage = memo(({ colSpan = 5, isLoading = false, icon = faSearch, description = 'Search for a customer by name, phone number, or email', placeholder = 'Search Customer', loadingMessage = 'Loading...' }) => {
    return (
        <div className={clsx('box p-4 overflow-x-auto intro-y', 'lg:overflow-x-auto', `col-span-${colSpan}`)}>
            <div className="flex flex-col items-center justify-center h-full py-20">{isLoading ? <LoadingState loadingMessage={loadingMessage} /> : <EmptyState icon={icon} description={description} placeholder={placeholder} />}</div>
        </div>
    );
});

EmptyPage.displayName = 'EmptyPage';
LoadingState.displayName = 'LoadingState';
EmptyState.displayName = 'EmptyState';

EmptyPage.propTypes = {
    colSpan: PropTypes.number,
    isLoading: PropTypes.bool,
    icon: PropTypes.object,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    loadingMessage: PropTypes.string
};

export default EmptyPage;
